<template>
  <div class="wrap">
    <div class="success-img">
      <img src="../assets/403.png" alt="" />
    </div>
    <div class="first-title">亲爱的六律小伙伴：</div>
    <div class="second-title">
      <span style="color: #de1d1d">
        您没有查看此数据的权限哦！我们的数据均为
        真实数据，严格执行数据保密，严禁私下转发。</span
      >
    </div>
    <div class="second-title">
      如想申请其他数据查看权限，可咨询产品技术小伙伴。
    </div>
  </div>
</template>
<script setup lang="ts">
</script>
<style scoped lang="less">
.wrap {
  // background: #eff2f5;
  height: 100%;
  .success-img {
    width: 4.26rem;
    height: 3.32rem;
    margin: 0.62rem auto;
    img {
      width: 100%;
    }
  }
  .first-title {
    font-size: 0.34rem;
    color: #282828;
    font-weight: 500;
  }
  .second-title {
    margin: 0.2rem 0.8rem;
    font-size: 0.28rem;
    color: #666666;
  }
}
</style>
